import { PerformanceEntryType } from '@ms/yammer-telemetry/dist/performance';

import { TelemetryEventType } from '../events';
import { enqueueAndThrottleReportLogEvents } from '../report/reportLog';

import getEventsForResourceEntries from './getEventsForResourceEntries';
import { GetEventsForPerformanceEntries } from './types';

const mappers: Record<PerformanceEntryType, GetEventsForPerformanceEntries> = {
  resource: getEventsForResourceEntries,
};

const isPerformanceObserverAvailable = () => 'performance' in window && 'PerformanceObserver' in window;

const reportEventsForEntries = (entryTypes: PerformanceEntryType[], list: PerformanceObserverEntryList) => {
  entryTypes.forEach((entryType) => {
    const entries = list.getEntriesByType(entryType);
    const getEventsForEntries = mappers[entryType];
    const events = getEventsForEntries(entries);
    if (events.length > 0) {
      enqueueAndThrottleReportLogEvents(TelemetryEventType.Performance, events);
    }
  });
};

type ConfigurePerformanceObserver = () => void;
export const configurePerformanceObserver: ConfigurePerformanceObserver = () => {
  if (!isPerformanceObserverAvailable()) {
    return;
  }

  const entryTypes: PerformanceEntryType[] = [PerformanceEntryType.Resource];

  // One-time report for entries created before configuring PerformanceObserver
  reportEventsForEntries(entryTypes, window.performance);

  const perfObserver = new PerformanceObserver((list: PerformanceObserverEntryList, _obj: PerformanceObserver) =>
    reportEventsForEntries(entryTypes, list)
  );
  perfObserver.observe({ entryTypes });
};
